@if (cameraActive) {
  <div class="camera-overlay">
    <div class="camera-hex-container" [class.flat-top]="isFlat">
      <video #cameraVideo autoplay playsinline muted></video>
    </div>
    <div class="camera-controls">
      <button type="button" class="camera-control-btn" (click)="closeCamera()">
        <span class="mat-sym">close</span>
      </button>
      <button type="button" class="camera-shutter" (click)="capturePhoto()"></button>
      @if (hasMultipleCameras) {
        <button type="button" class="camera-control-btn" (click)="switchCamera()">
          <span class="mat-sym">cameraswitch</span>
        </button>
      }
    </div>
  </div>
}
<input #cameraFallbackInput type="file" accept="image/*" capture="environment" hidden (change)="onFileSelect($event)" />
